import { HOST } from "../../config/urls"

export const exportMonth = (
  from: string,
  to: string,
  type: "excel" | "csv" = "excel"
  // month: number,
  // from?: string,
  // to?: string,
) => {
  // let url = `${HOST}/api/reports/monthly-worker-tasks?month=${month}&filetype=${type}`
  let url = `${HOST}/api/reports/monthly-worker-tasks?from=${from}&to=${to}&filetype=${type}`

  window.open(url, "_blank")
}

export const exportProject = (projectId: number) => {
  let url = `${HOST}/api/reports/project-tasks?projectId=${projectId}`
  window.open(url, "_blank")
}
